<template>
  <div>
    <navigationFab />
    <v-img
      src="https://images.unsplash.com/photo-1531297484001-80022131f5a1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1307&q=80"
      gradient="#FFFFFF00, #000000"
      max-height="25vh"
    >
      <v-row>
        <v-col class="mt-16" align="center">
          <span class="primary--text text-md-h2 text-h3 font-weight-bold"
            >Redirecting...</span
          >
        </v-col>
      </v-row>
    </v-img>
    <div class="body">
      <span class="px-8">
        You'll be redirected to login in {{ timerCount }}s. If it doesn't work
        click <a :href="this.$authUrl">here</a> ...</span
      >
    </div>
  </div>
</template>

<script>
import navigationFab from "../components/general/navigationFab";
export default {
  name: "redirectSpotify",
  title: "Redirecting...",
  components: {
    navigationFab,
  },
  data() {
    return {
      timerCount: 3,
    };
  },
  methods: {
    redirect: function () {
      window.location = this.$authUrl;
    },
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
          }, 1000);
        } else {
          this.redirect();
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },
  mounted() {
    if (this.$route.query.redirect) {
      this.$cookies.set("authRedirect", this.$route.query.redirect);
    }
  },
};
</script>

<style scoped>
.body {
  height: 75vh;
  display: grid;
  place-items: center;
}
</style>